import React from 'react'

interface CommentCountWithIconProps { hasUnreadComment: boolean, totalCommentCount: number }

const CommentCountWithIcon = ({ hasUnreadComment, totalCommentCount  }: CommentCountWithIconProps) =>
    <div className="comment-counts-container-parent">
        <div className='comment-counts-container'>
            <div className='comment-counts'><i className={`comment-counts-icon fa-message ${hasUnreadComment ? 'fa-solid' : 'fa-regular'}`}></i><span className='comment-counts-text'>{totalCommentCount || 0}</span></div>
        </div>
    </div>

export default CommentCountWithIcon
